/**
 * `/orca/v3/proposals/$proposalId` — one invocation proposal, for its person to read whole and approve.
 * Registers the route eagerly with its guard and stylesheets; the page itself is `$proposalId.lazy.tsx`, so
 * nothing it renders lands in the always-loaded chunk.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { v3BeforeLoad, v3Head } from "~/lib/v3-route.ts";

export const Route = createFileRoute("/orca/v3/proposals/$proposalId")({
  beforeLoad: v3BeforeLoad,
  head: v3Head,
});
